// UploadHero.js - For shop owners to upload hero image
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import "./style/UploadHero.css";

export default function UploadHero() {
    const navigate = useNavigate();
    const [heroImage, setHeroImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

     const api = "https://mkbackend-production.up.railway.app"
   const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                setError('Please select an image file');
                return;
            }
            
            if (file.size > 5 * 1024 * 1024) {
                setError('Image size should be less than 5MB');
                return;
            }

            setHeroImage(file);
            setError(null);
            
            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!heroImage) {
            setError('Please select an image');
            return;
        }

        setLoading(true);
        setMessage(null);
        setError(null);

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            // Get shop ID from token
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decoded = JSON.parse(jsonPayload);
            const shopId = decoded.id;

            const formData = new FormData();
            formData.append('image', heroImage);

            const res = await axios.post(
                `${api}/heroSection/${shopId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (res.data.success) {
                setMessage('✅ Hero image uploaded successfully!');
                setHeroImage(null);
                setImagePreview(null);
                document.getElementById('heroImageInput').value = '';
                
                // Navigate back after 2 seconds
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            } else {
                setError(res.data.message || 'Failed to upload image');
            }
        } catch (error) {
            console.error(error.message);
            setError(error.response?.data?.message || 'Error uploading image');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="upload-hero-container">
            <div className="upload-hero-card">
                <h2>🎨 Upload Hero Image</h2>
                <p>Add a hero image to your shop page</p>

                {message && (
                    <div className="upload-hero-message success">{message}</div>
                )}
                
                {error && (
                    <div className="upload-hero-message error">{error}</div>
                )}

                <form onSubmit={handleSubmit} className="upload-hero-form">
                    <div className="file-upload-wrapper">
                        <div className="file-upload-area">
                            {imagePreview ? (
                                <div className="image-preview-container">
                                    <img 
                                        src={imagePreview} 
                                        alt="Hero preview" 
                                        className="image-preview"
                                    />
                                    <button 
                                        type="button" 
                                        className="remove-image-btn"
                                        onClick={() => {
                                            setHeroImage(null);
                                            setImagePreview(null);
                                            document.getElementById('heroImageInput').value = '';
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <div className="upload-icon">🖼️</div>
                                    <p className="upload-text">Click to upload hero image</p>
                                    <p className="upload-subtext">PNG, JPG, WEBP (Max 5MB)</p>
                                </>
                            )}
                            <input
                                id="heroImageInput"
                                type="file"
                                onChange={handleImageSelect}
                                accept="image/*"
                                className="file-input"
                                disabled={loading}
                            />
                        </div>
                    </div>

                    <button 
                        type="submit" 
                        className="upload-hero-btn"
                        disabled={loading || !heroImage}
                    >
                        {loading ? (
                            <>
                                <span className="spinner"></span>
                                Uploading...
                            </>
                        ) : (
                            '🚀 Upload Hero Image'
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}